<div class="section-card" [formGroup]="group">
    <div class="section-header">
        <span class="s-icon">🏠</span>
        <h3>Address Details (Home)</h3>
    </div>
    <div class="section-body">
        <div class="row g-3">
            <div class="col-md-2">
                <div class="field">
                    <label class="field-label">Address Type <span class="req">*</span></label>
                    <select class="f-select" formControlName="address_type_id">
                        <option value="">Select Type</option>
                        @for (item of addressType; track item.value) {
                            @if (item.label == 'Home') {
                                <option [value]="item.value">{{ item.label }}</option>
                            }
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-5">
                <div class="field">
                    <label class="field-label">House Number / Block <span class="req">*</span></label>
                    <input class="f-input" formControlName="address_line_1" placeholder="e.g. Flat 12, Block B">
                </div>
            </div>
            <div class="col-md-5">
                <div class="field">
                    <label class="field-label">Street / Area <span class="req">*</span></label>
                    <input class="f-input" formControlName="address_line_2" placeholder="Building, Street, Area">
                </div>
            </div>
            <div class="col-md-4">
                <div class="field">
                    <label class="field-label">State <span class="req">*</span></label>
                    <select class="f-select" formControlName="state_id">
                        <option value="">Select State</option>
                        @for (s of states; track s.name) {
                            <option [value]="s.id">{{ s.name }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="field">
                    <label class="field-label">City <span class="req">*</span></label>
                    <select class="f-select" formControlName="city_id">
                        <option value="">Select City</option>
                        @for (c of cities; track c.name) {
                            <option [value]="c.id">{{ c.name }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="field">
                    <label class="field-label">PIN Code <span class="req">*</span></label>
                    <input (input)="numbersOnly.emit($event)"
                           class="f-input"
                           formControlName="pin_code"
                           inputmode="numeric"
                           maxlength="6"
                           placeholder="6-digit PIN"
                           type="text">
                </div>
            </div>
        </div>
    </div>
</div>
